<template>
    <v-layout v-if="dropBoxOptions.length === 0">
        <v-text-field
            class="ucFirst body-2"
            :aria-label="formattedAriaLabel(
                metadata[`description${this.upperLocale}`],
                required
            )"
            :label="formattedLabel(
                metadata[`description${this.upperLocale}`],
                required
            )"
            :hint="$t('appt.priorityGroup.hint')"
            persistent-hint
            :outlined="outlined"
            append-icon="fas fa-user-friends"
            :value="value"
            :name="metadata.name"
            :color="$vuetify.theme.primary"
            :background-color="$vuetify.theme.primary"
            :data-testid="metadata.name"
            :maxlength="maxLength"
            counter
            :rules="[
                !required || requiredField()
            ]"
            :data-meta-id="metadata.id"
            :id="metadata.name"
            @input="emitValue"
        />
    </v-layout>
    <v-layout v-else class="my-4 border">
        <v-flex class="pa-2 subheading mb-0 grey--text text--darken-2">
            {{ formattedLabel(
                metadata[`description${this.upperLocale}`],
                required)
            }}

            <v-radio-group
                class="body-2 ml-6 mt-0"
                :value="value"
                :outlined="outlined"
                :color="$vuetify.theme.primary"
                type="radio"
                :rules="[!required || requiredField()]"
                :id="metadata.name"
                @change="emitValue"
            >
                <v-radio
                    v-for="item in dropBoxOptions"
                    :label="getLabelText(item)"
                    :value="item"
                    :key="item" />
            </v-radio-group>
        </v-flex>
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { formRules } from '@/mixins/form-rules';
import { mapGetters } from 'vuex';
import { get, find, includes, replace } from 'lodash';
import { GenericVaccineServiceTemplateIds, ServiceSettings } from '@/enums';

export default {
    name: 'priority-group',
    mixins: [formRules, inputHelpers],
    props: {
        metadata: { type: Object, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: [String, Boolean, Number], required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
        serviceId: { type: Number, required: false, default: null },
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
            getEstablishmentId: 'establishment/getEstablishmentId',
            getInstantiateServiceById: 'services/getInstantiateServiceById',
            currentEstSettings: 'services/getCurrentEstSettings',
        }),

        appendIcon() {
            return this.withIcon ? 'fas fa-caret-down' : '';
        },
        dropBoxOptions() {
            let options = find(this.currentEstSettings, ['setting', ServiceSettings.PRIORITY_GROUP_OPTIONS]);
            return options ? options.value : [];
        },
        maxLength() {
            return this.metadata && this.metadata.rules && this.metadata.rules.maxLength;
        },
        getTitle() {
            if (this.hasGenericVaccineService) {
                return this.$i18n.t('appt.priorityGroup.genericVaccine.title');
            }
            return this.$i18n.t('appt.priorityGroup.title');
        },
        hasGenericVaccineService() {
            const service = this.getInstantiateServiceById(this.serviceId);
            const serviceTemplateId = get(service, 'serviceTemplate.id', -1);
            return includes(GenericVaccineServiceTemplateIds, serviceTemplateId);
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', value);
        },

        getLabelText(item) {
            if (this.hasGenericVaccineService) {
                const minAgeToBookPatient = find(this.currentEstSettings, ['setting', ServiceSettings.MIN_AGE_TO_BOOK_PATIENT]);
                return replace(this.$i18n.t(`appt.priorityGroup.${item}`), '%MIN_AGE_FOR_BOOKING%', minAgeToBookPatient.value);
            }

            // Custom text for nothing option for certain establishments
            if (item === 'nothing' &&
                (
                    (this.getEstablishmentId >= 60000 && this.getEstablishmentId <= 60999) ||
                    (this.getEstablishmentId >= 68000 && this.getEstablishmentId <= 68999)
                )
            ) {
                return this.$i18n.t('appt.priorityGroup.nothing14');
            }
            else {
                return this.$i18n.t('appt.priorityGroup.' + item);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.border::v-deep {
    border: 2px solid var(--v-border-metadata-color)!important;
    border-radius: 4px!important;
}

.filter li {
    list-style-type: disc !important;

}
</style>
